const rankingData = [
  { rank: 1, title: '某顶流艺人私下行程全曝光，多人证实细节吻合', heat: '98.7万', tag: '爆', tagColor: 'bg-primary-500' },
  { rank: 2, title: '热门综艺录制现场冲突画面流出，节目组紧急回应', heat: '86.2万', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 3, title: '知名品牌代言人合约纠纷升级，多方博弈内幕揭晓', heat: '74.5万', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 4, title: '年度大剧选角风波持续发酵，制片人深夜发长文', heat: '63.1万', tag: '新', tagColor: 'bg-secondary-500' },
  { rank: 5, title: '跨平台主播转会消息坐实，签约金额创行业新高', heat: '52.8万', tag: '新', tagColor: 'bg-secondary-500' },
  { rank: 6, title: '娱乐圈知名夫妻档被曝分居，双方团队保持沉默', heat: '41.3万', tag: '', tagColor: '' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-section-offset">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">热度榜单</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-4">实时追踪全网最受关注的热门爆料话题</p>

        <div className="space-y-3">
          {rankingData.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-background-100 hover:bg-background-200 rounded-lg transition-colors group cursor-pointer"
            >
              <div className={`w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg font-bold text-sm ${
                i < 3
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-800 group-hover:text-primary-600 transition-colors truncate font-medium">
                  {item.title}
                </p>
              </div>
              {item.tag && (
                <span className={`px-2 py-0.5 rounded text-xs font-semibold text-white whitespace-nowrap ${item.tagColor}`}>
                  {item.tag}
                </span>
              )}
              <span className="text-xs md:text-sm text-foreground-400 whitespace-nowrap font-medium">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}